import { EventDay } from '@/types/EventDay.ts'
import { DaycareType } from '@/types/Daycare.ts'
import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import EditEventDay from './editEventDay.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'

interface EditEventDayDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    daycareType?: DaycareType
    event: EventDay
    refetchAllEvents: () => Promise<void>
}

const EditEventDayDialog: FunctionComponent<EditEventDayDialogProps> = ({
    open,
    handleClose,
    daycareId,
    daycareType,
    event,
    refetchAllEvents
}: EditEventDayDialogProps) => {
    const { t } = useTranslation()

    const [title, setTitle] = useState<string>('')
    const [date, setDate] = useState<string>(moment().format('DD-MM-YYYY'))

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('editEventDay')} />
            <DialogBody>
                <EditEventDay
                    create={false}
                    daycareId={daycareId}
                    daycareType={daycareType}
                    handleClose={handleClose}
                    refetchAllEvents={refetchAllEvents}
                    event={event}
                    setTitle={setTitle}
                    title={title}
                    date={date}
                    setDate={setDate}
                />
            </DialogBody>
        </Dialog>
    )
}

export default EditEventDayDialog
